import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { ExtendedPickerLoadingContentProps } from './PickerLoadingContent.types';
import Spinner from '@photosi/rn-components/spinner/Spinner';

export const PickerLoadingContent = observer(({ customStyles, text }: ExtendedPickerLoadingContentProps) => {
  const { i18n } = useStore();

  return (
    <View style={customStyles.loadingContentDetails}>
      <Spinner />
      <TextLato style={customStyles.loadingContentText}>{i18n.t(text || 'upload:loading-description')}</TextLato>
    </View>
  );
});
